<!-- ── Shared content blocks (used by both layouts) ── -->
<ng-template #overviewBlock>
  <!-- ── Enhanced overview ── -->
  <div class="v2">
    <!-- Short description -->
    @if (asset().short_description) {
      <p class="v2-short-desc" style="color: #1a1a1a">{{ asset().short_description }}</p>
    }

    <!-- Key overview fields -->
    <div class="table table--v2">
      @if (asset().asset_type === 'Dataset') {
        <div class="row" [class.row--empty]="!asset().purpose">
          <span class="row-label">Purpose</span>
          <span class="row-value">{{ asset().purpose || '—' }}</span>
        </div>
        <div class="row" [class.row--empty]="!asset().intended_use">
          <span class="row-label">Intended Use</span>
          <span class="row-value">{{ asset().intended_use || '—' }}</span>
        </div>
        <div class="row" [class.row--empty]="!asset().target_audience">
          <span class="row-label">Target Audience</span>
          <span class="row-value">{{ asset().target_audience || '—' }}</span>
        </div>
        <div class="row" [class.row--empty]="!timePeriod()">
          <span class="row-label">Time Period</span>
          <span class="row-value">{{ timePeriod() || '—' }}</span>
        </div>
      }
      <div class="row" [class.row--empty]="!geographicalCoverageDisplay()">
        <span class="row-label">Geographical Coverage</span>
        <span class="row-value">{{ geographicalCoverageDisplay() || '—' }}</span>
      </div>
    </div>
  </div>
</ng-template>

<!-- ── Source & Governance tab (enhanced only) ── -->
<ng-template #sourceBlock>
  <div class="table">
    @if (asset().asset_type === 'Dataset') {
      <div class="row" [class.row--empty]="!asset().license_type">
        <span class="row-label">License Type</span>
        <span class="row-value">{{ asset().license_type || '—' }}</span>
      </div>
    }
    <div class="row" [class.row--empty]="!asset().permitted_use">
      <span class="row-label">Permitted Use</span>
      <span class="row-value">{{ asset().permitted_use || '—' }}</span>
    </div>
    <div class="row">
      <span class="row-label">Redistribution Restrictions</span>
      <span class="row-value">{{
        asset().redistribution_allowed ? 'Allowed' : 'Not Allowed'
      }}</span>
    </div>
    <div class="row">
      <span class="row-label">Publication Restrictions</span>
      <span class="row-value">{{
        asset().external_publication_allowed ? 'Allowed' : 'Not Allowed'
      }}</span>
    </div>
    <div class="row" [class.row--empty]="!asset().access">
      <span class="row-label">Access</span>
      <span class="row-value">{{ accessTypeDisplay() || '—' }}</span>
    </div>
    <div class="row" [class.row--empty]="!asset().limitations">
      <span class="row-label">Limitations</span>
      <span class="row-value">{{ asset().limitations || '—' }}</span>
    </div>
  </div>
</ng-template>

<!-- ── Technical Information tab (enhanced only) ── -->
<ng-template #technicalBlock>
  <div class="table">
    @if (isDatasetOrAiToolAgent()) {
      <div class="row" [class.row--empty]="!asset().format">
        <span class="row-label">Format</span>
        <span class="row-value">{{ asset().format || '—' }}</span>
      </div>
      <div class="row" [class.row--empty]="!asset().size_display">
        <span class="row-label">Size</span>
        <span class="row-value">{{ asset().size_display }}</span>
      </div>
    }
    <div class="row" [class.row--empty]="!asset().ingestion_method">
      <span class="row-label">Update Method</span>
      <span class="row-value">{{ asset().ingestion_method || '—' }}</span>
    </div>
    <div class="row" [class.row--empty]="!asset().update_frequency">
      <span class="row-label">Update Frequency</span>
      <span class="row-value">{{ asset().update_frequency || '—' }}</span>
    </div>
    <div class="row" [class.row--empty]="!asset().current_version">
      <span class="row-label">Current Version</span>
      <span class="row-value">{{ asset().current_version }}</span>
    </div>
    <div class="row" [class.row--empty]="!lastUpdatedDisplay()">
      <span class="row-label">Last Updated</span>
      <span class="row-value">{{ lastUpdatedDisplay() || '—' }}</span>
    </div>
  </div>
</ng-template>

@if (activeTab() === 'overview') {
  <ng-container *ngTemplateOutlet="overviewBlock"></ng-container>
}
@if (activeTab() === 'source' && true) {
  <ng-container *ngTemplateOutlet="sourceBlock"></ng-container>
}
@if (activeTab() === 'technical' && true) {
  <ng-container *ngTemplateOutlet="technicalBlock"></ng-container>
}
